import { Loader } from '@any-ui-react/core';

import { AnyChatForm } from '@anyx/feature-crm';

export const AiAutoReplyConfigFormLoader = () => {
  return (
    <AnyChatForm.Form>
      <AnyChatForm.Block>
        <Loader size="sm" />
      </AnyChatForm.Block>
    </AnyChatForm.Form>
  );
};
